import React from 'react';
import { calendlyLink } from '../mock';

const FloatingBookButton = () => {
  return (
    <a
      href={calendlyLink}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        position: 'fixed',
        bottom: '32px',
        right: '32px',
        background: '#A0D8D2',
        color: '#1a1a1a',
        border: 'none',
        borderRadius: '0px',
        padding: '19px 23px',
        minWidth: '210px',
        height: '60px',
        fontSize: '14px',
        fontWeight: 500,
        cursor: 'pointer',
        textDecoration: 'none',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)'
      }}
      className="floating-book-btn"
    >
      Book Your Free Discovery Session
      <style>{`
        .floating-book-btn:hover {
          background: #8BCCC5 !important;
          transform: translateY(-2px);
          box-shadow: 0 6px 24px rgba(0, 0, 0, 0.2);
        }
        @media (max-width: 640px) {
          .floating-book-btn {
            bottom: 16px;
            right: 16px;
            left: 16px;
            min-width: auto;
            font-size: 13px;
            padding: 16px 20px;
            height: 52px;
          }
        }
      `}</style>
    </a>
  );
};

export default FloatingBookButton;
